import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import { SoftSkillsForm } from './SoftSkillsForm';

export const SoftSkillsStep = () => {
  const { values, setFieldValue } = useFormikContext<CVBuilderFormValues>();
  const { isEditMode } = useEditModeNavigation();

  const handleRemoveSkill = (skillToRemove: string) => {
    const newSkills =
      values.softSkills?.filter(skill => skill !== skillToRemove) || [];
    void setFieldValue('softSkills', newSkills);
  };

  const handleSkillChange = (newSkills: string[]) => {
    void setFieldValue('softSkills', newSkills);
  };

  // The step progress indicator moved into the shared StepHeader (rendered by
  // StepContentSwitch), so it no longer needs repeating inside every step card.
  const content = (
    <ContentCard
      title={getTrans('cvBuilderPage.softSkills.title')}
      titleVariant="h4"
    >
      <SoftSkillsForm
        handleSkillChange={handleSkillChange}
        handleRemoveSkill={handleRemoveSkill}
      />
    </ContentCard>
  );

  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {content}
      <Box sx={{ flex: 1 }} />
      {isEditMode ? (
        <EditModeNavigationButtons />
      ) : (
        <>
          <StepNavigationButton step="SOFT_SKILLS" />
          <PreviousStepNavigationButton step="SOFT_SKILLS" />
        </>
      )}
    </RootBox>
  );
};
